module.exports = __webpack_public_path__ + "img/icon_map_51_on_011.47e1ecac.png";